import React, { useCallback, useEffect, useMemo, useState } from "react";
import CommentSwiper from "./../commentSwiper/CommentSwiper";
import { CommentJson } from "features/comment/types/comment.type";
import { Col, Image, Row } from "antd";
import FileModel from "common/models/FileModel";
import CommentItem from "../commentItem/CommentItem";
import { ImageJson } from "features/comment/types/gallery.type";
import ReviewDetailRight from "./ReviewDetailRight";

export interface ReviewDetailList extends CommentJson {
  activeImage?: number;
}
type Props = {
  dataSource: ReviewDetailList[];
  dataReviewDetail?: CommentJson[];
  defaultIndexSlide: number;
  defaultIndexImg?: number;
  defaultImageItem?: ImageJson;
  navigation?: boolean;
  visible: boolean;
  defaultIndexImageFunc?: (
    index: number,
    id: number,
    arr: CommentJson[]
  ) => number;
  showLinkMore?: boolean;
  handleShowMore?: () => void;
};
const ReviewDetail = ({
  dataSource,
  dataReviewDetail,
  defaultIndexSlide,
  navigation = true,
  defaultIndexImg = 0,
  defaultImageItem,
  defaultIndexImageFunc,
  visible,
  showLinkMore,
  handleShowMore,
}: Props) => {
  const [dataDetail, setDataDetail] = useState<ReviewDetailList>(
    dataSource[defaultIndexSlide]
  );
  const [dataSourceReview, setDataSourceReview] =
    useState<ReviewDetailList[]>(dataSource);

  const [indexImage, setIndexImage] = useState(defaultIndexImg);
  const [slideIndex, setSlideIndex] = useState(defaultIndexSlide);
  // const [activeIndex, setActiveIndex];
  const [count, setCount] = useState(0);
  const [imageUrl, setImageUrl] = useState("");
  // function

  const handleConverImageFile = (url: string) => {
    return FileModel.getThumbnailFromUrl(url, 500, 500, "crop");
  };

  const handleSetNewData = (swiper: any) => {
    const { activeIndex, previousIndex } = swiper;

    let urlImage = "";
    setCount(swiper.realIndex);
    setDataDetail(dataSource[swiper.realIndex]);
    if (activeIndex > previousIndex) {
      // Xử lý logic khi chuyển đến slide tiếp theo
      if (activeIndex >= 1) {
        if (dataSource[activeIndex].id === dataSource[previousIndex].id) {
          // setImageUrl(urlImage);
        } else {
          // setDefaultIndexImage(defaultIndexImg);
          // urlImage = handleConverImageFile(
          //   dataSource[activeIndex].images[0].file_path
          // );
          // setImageUrl(urlImage);
        }
      }
    } else if (activeIndex < previousIndex) {
      // if (dataSource[activeIndex].id === dataSource[previousIndex].id) {
      //   if (defaultIndexImg > 0) {
      //     setDefaultIndexImage((prev) => prev - 1);
      //     urlImage = handleConverImageFile(
      //       dataSource[activeIndex].images[indexImage].file_path
      //     );
      //     setImageUrl(urlImage);
      //   }
      // } else {
      //   setDefaultIndexImage(dataSource[activeIndex].images.length - 1);
      //   urlImage = handleConverImageFile(
      //     dataSource[activeIndex].images[
      //       dataSource[activeIndex].images.length - 1
      //     ].file_path
      //   );
      //   setImageUrl(urlImage);
      // }
      // Xử lý logic khi chuyển đến slide trước đó
    }
  };

  // const handleSetDefaultIndexSlide = (index) => {};

  const handleSetUrlImage = useCallback((url: string) => {
    setImageUrl(url);
  }, []);

  const handleChangeSlideIndex = (id: number, indexActive: number) => {
    const index = dataSource.findIndex((object) => {
      return object.id === id;
    });
    setSlideIndex(index + indexActive);
  };

  ///////////////////////

  useEffect(() => {
    setDataDetail(dataSource[defaultIndexSlide]);
    return () => {
      setCount(0);
    };
  }, [defaultIndexSlide, dataSource]);

  useEffect(() => {
    setSlideIndex(defaultIndexSlide);
    return () => {
      setSlideIndex(0);
    };
  }, [defaultIndexSlide]);

  ///////////////////////

  const slide = useMemo(() => {
    return (
      <CommentSwiper
        idSwiper="review_detail"
        autoplay={false}
        isloading={false}
        navigation={navigation}
        styleButton={{
          width: "32px",
          height: "32px",
          border: "none",
          zIndex: 999999999999999999999999,
        }}
        speed={300}
        slidesPerView={1}
        setButtonNext="react-button-next-review-detail"
        setButtonPrev="react-button-prev-review-detail"
        initialSlide={slideIndex}
        slidesPerGroup={1}
        styleButton_next={{ right: "-16px" }}
        styleButton_prev={{ left: "-16px" }}
        dataSource={dataSource}
        classButtonSlide="slide-review-detail"
        onSlideChange={(swiper) => {
          setImageUrl("");
          handleSetNewData(swiper);
        }}
        itemRender={(item: ReviewDetailList) => {
          return (
            <Image
              data-id={item.id}
              id="image_left"
              src={
                imageUrl.length > 0
                  ? imageUrl
                  : item.images.length > 0 &&
                    item.activeImage !== undefined &&
                    item.images[item.activeImage].file_path !== undefined
                  ? FileModel.getThumbnailFromUrl(
                      item.images[item.activeImage].file_path,
                      500,
                      500,
                      "crop"
                    )
                  : ""
              }
              preview={false}
              style={{
                borderRadius: "4px",
                objectFit: "cover",
                height: "100%",
              }}
              fallback="data:image/png;base64,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"
            ></Image>

            // <div>sdf</div>
          );
        }}
        responsive={{
          xxs: { slidesPerView: 1, spaceBetween: 8 },
          xs: { slidesPerView: 1, spaceBetween: 8 },
          sm: { slidesPerView: 1, spaceBetween: 8 },
          md: { slidesPerView: 1, spaceBetween: 8 },
          lg: { slidesPerView: 1, spaceBetween: 8 },
          xl: { slidesPerView: 1, spaceBetween: 8 },
        }}
      ></CommentSwiper>
    );
  }, [defaultIndexSlide, imageUrl, slideIndex]);
  return (
    <article
      style={{ height: "100%", width: "100%" }}
      id="review-detail-wrapper"
    >
      <div
        id="review_body"
        style={{ width: "100%", height: "100%", display: "flex" }}
      >
        <div className="review_body_left">
          {/* {dataSourceReview.length > 0 && */}
          {slide}
          {/* <CommentSwiper
            autoplay={false}
            isloading={false}
            navigation={navigation}
            styleButton={{
              width: "32px",
              height: "32px",
              border: "none",
              zIndex: 999999999999999999999999,
            }}
            initialSlide={defaultIndexSlide > 0 ? defaultIndexSlide : 0}
            slidesPerGroup={1}
            styleButton_next={{ right: "-16px" }}
            styleButton_prev={{ left: "-16px" }}
            dataSource={dataSourceReview}
            classButtonSlide="slide-review-detail"
            onSlideChange={(swiper) => {
              setImageUrl("");
              handleSetNewData(swiper);
            }}
            itemRender={(item: CommentJson, index) => {
              return (
                <Image
                  key={index}
                  id="image_left"
                  src={
                    imageUrl.length > 0
                      ? imageUrl
                      : item.images.length > 0
                      ? FileModel.getThumbnailFromUrl(
                          item.images[defaultIndexImage].file_path || "",
                          1080,
                          765,
                          "crop"
                        )
                      : ""
                  }
                  preview={false}
                  style={{
                    borderRadius: "4px",
                    objectFit: "cover",
                    height: "100%",
                  }}
                  fallback="data:image/png;base64,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"
                ></Image>

                // <div>sdf</div>
              );
            }}
            responsive={{
              xxs: { slidesPerView: 1, spaceBetween: 8 },
              xs: { slidesPerView: 1, spaceBetween: 8 },
              sm: { slidesPerView: 1, spaceBetween: 8 },
              md: { slidesPerView: 1, spaceBetween: 8 },
              lg: { slidesPerView: 1, spaceBetween: 8 },
              xl: { slidesPerView: 1, spaceBetween: 8 },
            }}
          ></CommentSwiper> */}
        </div>
        <div className="review_body_right">
          <ReviewDetailRight
            handleSetUrlImage={handleSetUrlImage}
            data={dataDetail}
            handleChangeSlide={handleChangeSlideIndex}
            showLinkMore={showLinkMore}
            handleShowMore={handleShowMore}
          ></ReviewDetailRight>
        </div>
      </div>
    </article>
  );
};

export default ReviewDetail;
